import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import CommandWall from "./pages/CommandWall";
import PlatformWorkspace from "./pages/PlatformWorkspace";
import Risk from "./pages/Risk";
import Logs from "./pages/Logs";
import IntelligenceGrid from "./pages/IntelligenceGrid";
import ResetPassword from "./pages/ResetPassword";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" />;
}

function PublicOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" /> : children;
}

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <CommandWall /> : <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public */}
            <Route path="/" element={<HomeRoute />} />
            <Route path="/login" element={<PublicOnlyRoute><Auth mode="login" /></PublicOnlyRoute>} />
            <Route path="/signup" element={<PublicOnlyRoute><Auth mode="signup" /></PublicOnlyRoute>} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected app */}
            <Route path="/app" element={<ProtectedRoute><CommandWall /></ProtectedRoute>} />
            <Route path="/platform/:platformId" element={<ProtectedRoute><PlatformWorkspace /></ProtectedRoute>} />
            <Route path="/intelligence" element={<ProtectedRoute><IntelligenceGrid /></ProtectedRoute>} />
            <Route path="/risk" element={<ProtectedRoute><Risk /></ProtectedRoute>} />
            <Route path="/logs" element={<ProtectedRoute><Logs /></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
